// ReturnsMenu.tsx
import React from 'react';
import { Box, Heading, Stack } from '@chakra-ui/react';
import { RefundStatus } from '../../../../modules/refunds/types';
import { ButtonCustom } from '../../UI';
import { SettingsIcon } from '@chakra-ui/icons';

interface ReturnsMenuProps {
  activeStatus: number;
  onStatusChange: (status: number) => void;
  onCreate: () => void;
}

export const ReturnsMenu: React.FC<ReturnsMenuProps> = ({
  activeStatus,
  onStatusChange,
  onCreate,
}) => (
  <Box bg="white" width="250px" p={8}>
    <Heading size="lg" mb={4}>
      Возвраты
    </Heading>

    <ButtonCustom variant="withBackground" width="100%" mb={4} onClick={onCreate}>
      Создать
    </ButtonCustom>

    <Stack spacing={2} alignItems="flex-start">
      {[
        { label: 'Все', status: RefundStatus.NEW, icon: SettingsIcon },
        { label: 'В процессе', status: RefundStatus.IN_PROGRESS, icon: SettingsIcon },
        { label: 'Одобрено', status: RefundStatus.APPROVED, icon: SettingsIcon },
        { label: 'Отклонено', status: RefundStatus.REJECTED, icon: SettingsIcon },
      ].map(({ label, status, icon }) => (
        <MenuButtonItem
          key={status}
          icon={icon}
          label={label}
          isActive={activeStatus === status}
          onClick={() => onStatusChange(status)}
        />
      ))}
    </Stack>
  </Box>
);

interface MenuButtonItemProps {
  icon: React.ElementType;
  label: string;
  isActive: boolean;
  onClick: () => void;
}

const MenuButtonItem: React.FC<MenuButtonItemProps> = ({ icon, label, isActive, onClick }) => (
  <ButtonCustom
    leftIcon={icon}
    variant="withoutBackground"
    backgroundColor={isActive ? 'rgba(28, 28, 28, 0.05)' : ''}
    width="100%"
    justifyContent="flex-start"
    onClick={onClick}
  >
    {label}
  </ButtonCustom>
);
